import React, { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './FastPageTransition.css';
import { markPageEnter } from '../../utils/aos';
import { isViewTransitionRunning } from '../../utils/pageTransition';

// Khung của một trang. Trang vào bằng View Transitions (utils/pageTransition.js) thì hiệu ứng đã chạy ở đó nên gắn
// is-vt để tắt hiệu ứng CSS. Chỉ đọc một lần lúc mount: nếu bật/tắt theo class trên html thì lúc View Transitions
// xong, animation từ none trở lại thành tên keyframe và trang mới chạy lại hiệu ứng từ opacity 0 (chớp)
const PageFrame = ({ children }) => {
  const [viaViewTransition] = useState(isViewTransitionRunning);
  return (
    <div className={`fast-page-transition${viaViewTransition ? ' is-vt' : ''}`}>
      {children}
    </div>
  );
};

// Chuyển trang: gắn key theo đường dẫn để trang mới chạy hiệu ứng ngay từ khung hình đầu
// (không ẩn rồi hiện lại nên không bị chớp), cuộn lên đầu trước khi trình duyệt vẽ.
const FastPageTransition = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    markPageEnter();
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return <PageFrame key={location.pathname}>{children}</PageFrame>;
};

export default FastPageTransition;
